import { FC } from "react";

import { cx } from "../../../utils/cx";
import styles from "./PunchupSpinner.module.css";

export interface PunchupSpinnerProps {
  size?: number;
  /**
   * Colour treatment:
   * - `"primary"` (default) — orange sweep on a grey ring; the standalone loading indicator.
   * - `"current"` — the sweep + a faint ring inherit `currentColor`, so the spinner stays visible against a
   *   coloured background (e.g. white on a destructive red button). Use inside coloured buttons / dialogs —
   *   this is the mode that lets `PunchupSpinner` cover the legacy `currentColor`-adaptive loaders.
   */
  variant?: "primary" | "current";
}

export const PunchupSpinner: FC<PunchupSpinnerProps> = ({
  size = 24,
  variant = "primary",
}) => (
  <span
    className={cx(
      styles.spinner,
      variant === "current" && styles.spinnerCurrent
    )}
    style={{ width: size, height: size }}
    role="status"
    aria-label="Loading"
    data-variant={variant}
  />
);
